
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface MenuItemProps {
  to?: string;
  icon: ReactNode;
  label: string;
  onClick?: () => void;
}

export default function MenuItem({ to, icon, label, onClick }: MenuItemProps) {
  const content = (
    <div className="flex items-center space-x-2">
      <div className="w-8 h-8 flex items-center justify-center rounded-md bg-background">
        {icon}
      </div>
      <span className="text-base">{label}</span>
    </div>
  );
  
  if (to) {
    return (
      <Link 
        to={to} 
        className="flex items-center space-x-2 py-4 px-3 hover:bg-accent rounded-md"
        onClick={onClick}
      >
        {content}
      </Link>
    );
  }
  
  if (onClick) {
    return (
      <Button 
        variant="ghost" 
        className="w-full justify-start py-4 text-base" 
        onClick={onClick}
      >
        {content}
      </Button>
    );
  }
  
  return null;
}
